import { TAGS_KEYS } from "../../../other/constants/TagsKeys.jsx";
import { ModelTagsMixin } from "./ModelTagsMixin.jsx";

export const ResourceModelTagMixin = (target) =>
  class extends ModelTagsMixin(target) {
    static get fields() {
      return [
        { name: "typeId", dataSource: "type" },
        // local fields only
        { name: "_type", persist: false },
        // display fields for grid
        { name: "typeValue", persist: false },
        { name: "_icon", persist: false },
        { name: "iconId", dataSource: "icon" },
        { name: "iconValue", persist: false }
      ];
    }

    static swivuGetFieldOriginalSourceName(fieldName) {
      const fieldsMaps = {
        iconValue: "icon",
        typeValue: "type"
      }
      return fieldsMaps[fieldName] || super.swivuGetFieldOriginalSourceName?.(fieldName);
    }

    get typeStore() {
      return this.project && this.project.resourceTypeStore;
    }

    get _type() {
      return this.getTagValue(this.typeStore, "type");
    }
    set _type(type) {
      const typeId = type && typeof type === "object" ? type.id : type || null;
      const typeInstance = typeId ? this.typeStore.getById(typeId) : null;
      const typeValue = typeInstance ? typeInstance?.description ?? null : null;

      this.set({
        typeId,
        _type: null,
        typeValue
      });
    }

    get typeValue() {
      return this._type?.description;
    }

    set typeValue(value) {
      this._type = value
        ? this.typeStore.find((type) => type.description === value)
        : null;
    }

    get _icon() {
      return this.getTagValue(this.tagStore, "icon");
    }

    set _icon(icon) {
      const iconId = icon && typeof icon === "object" ? icon.id : icon || null;
      const iconValue = iconId
        ? this.tagStore.getById(iconId)?.tagValue ?? null
        : null;
      this.set({
        iconId,
        _icon: null,
        iconValue
      });
    }

    // value fields for grid
    get iconValue() {
      return this._icon?.tagValue;
    }

    set iconValue(value) {
      this._icon = value
        ? this.tagStore.find(
            (tag) => tag.tagSet === TAGS_KEYS.icon && tag.tagValue === value
          )
        : null;
    }
  };
